import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectField from '../../../components/forms/SelectField';
import Input from '../../../components/forms/Input';
import TextArea from '../../../components/forms/TextArea';
import DatePicker from '../../../components/forms/Datepicker';
import * as selectors from '../../../selectors/admin/models/contracts';
import { capitalize } from 'lodash';
import {
    fetchArtists,
    fetchSigners,
    fetchArtistsAndEntries,
    fetchEntries,
    fetchPartners,
    fetchEmailsForContract
} from '../../../actions/admin/models/contracts';
import SigningUsers from '../../../components/admin/forms/contracts/SigningUsers';
import {
    fetchingSubDependenciesSelector,
    fetchedSubDependenciesSelector,
    artistOptionsSelector
} from '../../../selectors/admin/forms';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { last, find } from 'lodash';
import { ALL_PERFORMANCES_OPTIONS } from '../../../constants/admin/settings';
import { timeToMs } from '../../../lib/date.utils';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import {
    getContractDueDate,
    getContractEvent,
    storeContractDueDate,
    storeContractEvent
} from '../../../services/local.storage';
import ImageUpload from '../../../components/forms/ImageUpload';
import { Snackbar } from '@material-ui/core';
import { CONTRACT_TYPES } from '../../../constants/settings';

class ContractInputs extends Component {
    state = {
        rememberEventDone: false,
        rememberDateDone: false,
        showCopyToast: false
    };
    componentDidMount() {
        const typeSet = new URLSearchParams(window.location.search).get('type');
        if (!this.props.isFetching && !this.props.fetched) {
            this._fetchDependencies();
        }
        if (typeSet === CONTRACT_TYPES.CLEARANCE || typeSet === CONTRACT_TYPES.PERFORMANCE) {
            this.props.onInput(typeSet, 'type');
        }
    }
    componentDidUpdate() {
        if (!this.props.isFetching && !this.props.fetched) {
            this._fetchDependencies();
        }
        if (
            !this.props.isUpdate &&
            !this.state.rememberEventDone &&
            getContractEvent() &&
            find(this.props.eventOptions, e => e.value === getContractEvent())
        ) {
            this.setState({ rememberEventDone: true });
            this._selectEvent(getContractEvent(), 'eventId');
        }
        if (!this.props.isUpdate && !isNaN(parseInt(getContractDueDate(), 10)) && !this.state.rememberDateDone) {
            this.setState({ rememberDateDone: true });
            this._setDueDate(parseInt(getContractDueDate(), 10), 'dueDate');
        }
    }
    _fetchDependencies() {
        const contextId = this.props.contextId;
        if (this.props.data.eventId && this.props.data.artistId) {
            this.props.fetchArtistsAndEntries(this.props.data.eventId, this.props.data.artistId, contextId);
            this.props.fetchPartners(this.props.data.eventId, contextId, false);
            this.props.fetchEmailsForContract(
                this.props.data.eventId,
                this.props.data.type || CONTRACT_TYPES.CLEARANCE
            );
        } else if (this.props.data.eventId) {
            this.props.fetchArtists(this.props.data.eventId, contextId);
            this.props.fetchPartners(this.props.data.eventId, contextId, false);
            this.props.fetchEmailsForContract(
                this.props.data.eventId,
                this.props.data.type || CONTRACT_TYPES.CLEARANCE
            );
        }
    }
    _selectEvent = (value, name) => {
        const { contextId } = this.props;
        const { events } = this.props.dependencies;
        const event = find(events, e => e.id === value);
        const organizationId = (event && event.organizationId) || '';
        this.props.onInput(value, name);
        this.props.onInput('', 'artistId');
        this.props.onInput(organizationId, 'organizationId');
        this.props.fetchArtists(value, contextId);
        this.props.fetchPartners(value, contextId, true);
        this.props.fetchEmailsForContract(event.id, this.props.data.type || CONTRACT_TYPES.CLEARANCE);
        storeContractEvent(value);
    };
    _selectArtist = (value, name) => {
        this.props.onInput(value, name);
        this.props.fetchEntries(this.props.data.eventId, value);
    };
    _setDueDate = (value, name) => {
        storeContractDueDate(value);
        this.props.onInput(value, name);
    };
    _selectPerformance = (value, name) => {
        if (last(value) === ALL_PERFORMANCES_OPTIONS.id) {
            this.props.onInput([ALL_PERFORMANCES_OPTIONS.id], name);
        } else {
            this.props.onInput(
                value.filter(a => a !== ALL_PERFORMANCES_OPTIONS.id),
                name
            );
        }
    };
    _selectTemplate = (value, name) => {
        this.props.onInput(value, name);
        const template = find(this.props.dependencies.templates, x => x.id === value);
        const templateClearing = (template && template.clearing) || {};
        const newClearing = this.props.data.clearing.map(cl => ({
            ...cl,
            live: templateClearing.live || cl.live,
            nonLinear: templateClearing.nonLinear || cl.nonLinear,
            useUntil: templateClearing.useUntil || cl.useUntil,
            comments: templateClearing.comments || cl.comments
        }));
        this.props.onInput(newClearing, 'clearing');
        this.props.onInput(template.logo || '', 'logo');
    };

    _copyPin = () => {
        return this._handleOpenToast();
    };

    _handleCloseToast = () => {
        this.setState({ showCopyToast: false });
    };

    _handleOpenToast = () => {
        this.setState({ showCopyToast: true });
    };

    render() {
        const errorEvent =
            this.props.selectedEvent &&
            (this.props.data.type === CONTRACT_TYPES.CLEARANCE
                ? !this.props.selectedEvent.defaultSignature || !this.props.selectedEvent.defaultSigner
                : !this.props.selectedEvent.performanceSignature || !this.props.selectedEvent.performanceSigner);
        const emailError = this.props.selectedEvent && find(this.props.dependencies.emails || [], e => !e.sender);

        let errorText = errorEvent
            ? `/!\\ No event ${(this.props.data.type || CONTRACT_TYPES.CLEARANCE).toLowerCase()} signature or signer`
            : emailError
              ? '/!\\ Custom email sender missing for this contract type'
              : '';

        return (
            <UserContext.Consumer>
                {user => {
                    const { signed, data } = this.props;
                    const editPermissions = hasPermissions(user, PERMISSIONS.CONTRACT_EDIT);

                    return (
                        <div className="ckp-admin-forms-body">
                            <Snackbar
                                className="ckp-snackbar ckp-snackbar--top"
                                open={this.state.showCopyToast}
                                autoHideDuration={3000}
                                onClose={this._handleCloseToast}
                                message="PIN Code copied to clipboard."
                                anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                            />
                            <div className="ckp-admin-grid-row">
                                <div className="ckp-admin-grid-column">
                                    <SelectField
                                        label="Event *"
                                        onChange={this._selectEvent}
                                        name="eventId"
                                        disabled={!!(!editPermissions || signed || data.id)}
                                        value={data.eventId}
                                        items={this.props.eventOptions}
                                        error={errorText}
                                    />
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <SelectField
                                        disabled={!editPermissions || !data.eventId || signed}
                                        items={this.props.artistOptions}
                                        label="Artist *"
                                        onChange={this._selectArtist}
                                        name="artistId"
                                        value={data.artistId}
                                    />
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <SelectField
                                        disabled={!editPermissions || !data.artistId || signed}
                                        items={this.props.performanceOptions}
                                        multiple={true}
                                        label="Artist's Performance"
                                        onChange={this._selectPerformance}
                                        name="performances"
                                        value={data.performances}
                                    />
                                </div>
                                <div className="ckp-admin-forms-image-right ckp-admin-grid-column">
                                    <ImageUpload
                                        label="Add logo"
                                        value={data.logo}
                                        name="logo"
                                        onChange={this.props.onInput}
                                        disabled={
                                            !editPermissions || !data.editing || signed || !this.props.data.eventId
                                        }
                                    />
                                </div>
                            </div>
                            <div className="ckp-admin-grid-row">
                                <div className="ckp-admin-grid-column">
                                    <SelectField
                                        disabled={
                                            !editPermissions || !data.editing || signed || !this.props.data.eventId
                                        }
                                        items={this.props.templateOptions}
                                        label="Contract Template"
                                        onChange={this._selectTemplate}
                                        name="templateId"
                                        value={data.templateId}
                                    />
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <DatePicker
                                        disabled={!editPermissions || signed}
                                        minDate={signed ? null : timeToMs()}
                                        value={data.dueDate > 0 ? data.dueDate : ''}
                                        onChange={this._setDueDate}
                                        label={'Contract Due Date *'}
                                        name={'dueDate'}
                                    />
                                </div>
                                <div className="ckp-admin-grid-column">
                                    <Input
                                        errorMessage={this.props.errors.status}
                                        label="Status"
                                        name="status"
                                        disabled={true}
                                        onChange={this.props.onInput}
                                        value={capitalize(data.version.state || '')}
                                    />
                                </div>
                            </div>
                            <div className="ckp-admin-grid-row">
                                <div className="ckp-admin-grid-column">
                                    <SigningUsers
                                        fetch={this.props.fetchSigners}
                                        artistId={data.artistId}
                                        eventId={data.eventId}
                                        organizationId={data.organizationId}
                                        shouldFetch={this.props.shouldFetchSigners}
                                        signers={this.props.signers}
                                        contractType={data.type}
                                    />
                                </div>
                                {data.type === CONTRACT_TYPES.PERFORMANCE && data.pinCode ? (
                                    <div className="ckp-admin-grid-column">
                                        <Input
                                            errorMessage={this.props.errors.status}
                                            label="PIN Code"
                                            name="pinCode"
                                            disabled={true}
                                            onChange={this.props.onInput}
                                            value={data.pinCode || ''}
                                            onCopy={this._copyPin}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <TextArea
                                className="is-extra-small"
                                name="notes"
                                onChange={this.props.onInput}
                                label="Notes (not visible for artist)"
                                value={data.notes}
                                maxLength={10000}
                            />
                        </div>
                    );
                }}
            </UserContext.Consumer>
        );
    }
}

const mapStateToProps = state => ({
    contextId: contextSubjectSelector(state),
    selectedEvent: selectors.selectedEventSelector(state),
    signed: selectors.isSignedSelector(state),
    eventOptions: selectors.eventOptionsSelector(state),
    artistOptions: artistOptionsSelector(state),
    performanceOptions: selectors.scheduleOptionsSelector(state),
    templateOptions: selectors.templateOptionsSelector(state),
    templates: selectors.templatesSelector(state),
    shouldFetchSigners: selectors.shouldFetchSignersSelector(state),
    signers: selectors.signersSelector(state),
    isFetching: fetchingSubDependenciesSelector(state),
    fetched: fetchedSubDependenciesSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { fetchEmailsForContract, fetchArtists, fetchArtistsAndEntries, fetchPartners, fetchSigners, fetchEntries },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractInputs);
